/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Harsh Raj",
  title: "Hi all, I'm Harsh",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 as well as Freelancer having an experience of building Web and Mobile applications with / ReactJS / VueJS / Nodejs / Flutter and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1q87RGuH46BgK5bo55KYEDGpQWrrWNKxu/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/harshraj6982",
  linkedin: "https://www.linkedin.com/in/harshraj-dev",
  gmail: "harshraj6982@gmail.com",
  //gitlab: "https://gitlab.com/harshraj6982",
  // facebook: "https://www.facebook.com/harshraj6982/",
  // stackoverflow: "https://stackoverflow.com/users/12069170/harsh-raj",
  whatsapp: "https://wa.me/917482988547",
  instagram: "https://www.instagram.com/harshraj.dev",
  twitter: "https://x.com/rajlogs",
  bluesky: "https://bsky.app/profile/harshraj.dev",
  discord: "https://discord.com/users/harshraj6982",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    // {
    //   skillName: "SASS",
    //   fontAwesomeClassname: "fab fa-sass"
    // },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "ReactJS",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "VueJS",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "Flutter",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "PHP",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "NodeJS",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "GoLang",
      fontAwesomeClassname: "fa-brands fa-golang"
    },
    {
      skillName: "MySQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    }
    // {
    //   skillName: "Docker",
    //   fontAwesomeClassname: "fab fa-docker"
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "IIT Patna",
      logo: require("./assets/images/iitpLogo.png"),
      subHeader: "Master of Science in AI and Cyber Security",
      duration: "July 2025 - Present",
      desc: "Actively involved in research and innovation in AI and cybersecurity, with contributions toward impactful projects and academic publications.",
      descBullets: [
        "Currently working on a research paper focused on scalable and secure system design architectures.",
        "Actively contributing to the tech community through mentorship, collaboration, and open-source involvement.",
        "Earned a finalist spot at MumbaiHacks 2025, recognized internationally as the largest in-person GenAI Hackathon."
      ]
    },
    {
      schoolName: "BIT Mesra",
      logo: require("./assets/images/bitmLogo.png"),
      subHeader: "Bachelor of Computer Applications",
      duration: "August 2021 - April 2024",
      desc:
        "Graduated in the top 10% of the program with a strong foundation in software development, systems programming, and web technologies.",
      descBullets: [
        "Developed a real-time face recognition and attendance system as part of a college project and Python coursework, enhancing accuracy and efficiency in attendance tracking",
        "Active member of the Information Technology Society; organized campus-wide tech events and managed digital presence.",
        "Winner of the 2022 National Smart India Hackathon and participant in international open-source events like Hacktoberfest."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Data Structure and Algorithm",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineering Intern",
      company: "The Cybertize",
      companylogo: require("./assets/images/cybertizeLogo.jpeg"),
      date: "May 2022 – July 2022",
      desc: "",
      bgColor: "linear-gradient(90deg, rgba(63,94,251,1) 0%, rgba(252,70,107,1) 100%)", //Optional
      descBullets: [
        "Build The Complete Backend on my own in NodeJS and MongoDB migrating from PHP MySQL.",
        "Wrote a Custom Python Script to fetch Data From MySQL and Write into MongoDB.",
        "Tech Stack Used - NodeJS, Express JS, MongoDB and Cloudinary."
      ]
    },
    // {
    //   role: "Front-End Developer",
    //   company: "Quora",
    //   companylogo: require("./assets/images/quoraLogo.png"),
    //   date: "May 2017 – May 2018",
    //   desc:
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // },
    // {
    //   role: "Software Engineer Intern",
    //   company: "Airbnb",
    //   companylogo: require("./assets/images/airbnbLogo.png"),
    //   date: "Jan 2015 – Sep 2015",
    //   desc:
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "harshraj6982", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/InterviewX.png"),
      projectName: "InterviewX",
      projectDesc: "AI Powered Mock Interviews Application",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://harshraj.dev/projects/InterviewX.html"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/carfinder.png"),
      projectName: "Carfinder",
      projectDesc: "A platform to find and compare used cars for sale",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.carfinder.co.in"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/seriesonott.png"),
      projectName: "Series On OTT",
      projectDesc: "Built a Bloging Website for Movies and Web Series",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.seriesonott.com/"
        }
        //  you can add extra buttons here.
      ]
    }
    // {
    //   image: require("./assets/images/avyl.png"),
    //   projectName: "AVYL School Management System",
    //   projectDesc:
    //     "Build a School Management System of a Mexian School of Physically Disabled People",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "http://app.avyl.com.mx/"
    //     }
    //   ]
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Flutter Course",
      subtitle: "Learnt how to make Apps in Flutter",
      image: require("./assets/images/udemy.svg"),
      footerLink: [
        {
          name: "Certification",
          url:
            "https://www.udemy.com/certificate/UC-3dba397d-5141-4a63-a45e-794895b8d732/"
        }
      ]
    },
    {
      title: "VueJS Course",
      subtitle: "Learnt how to make Web Apps in VueJS",
      image: require("./assets/images/lco.png"),
      footerLink: [
        {
          name: "Certification",
          url:
            "https://courses.learncodeonline.in/learn/certificate/1633571-92665"
        }
      ]
    },
    {
      title: "Ethical Hacking",
      subtitle:
        "Learnt about Cyber Security by performing various attack and its prevention",
      image: require("./assets/images/udemy.svg"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.udemy.com/certificate/UC-X0I1OD18/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/harshraj-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-7482988547",
  email_address: "harshraj6982@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "harshraj6982", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

// Analytics 
const analytics = {
  callMeBotNumber: process.env.REACT_APP_CALLMEBOT_NUMBER,
  callMeBotAPI: process.env.REACT_APP_CALLMEBOT_API
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  analytics
};
